import { useEffect } from 'react';

var useWindowResize = function useWindowResize(resizeEffect, deps) {
  useEffect(function () {
    window.addEventListener('resize', resizeEffect);
    return function () {
      return window.removeEventListener('resize', resizeEffect);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export { useWindowResize as default };
//# sourceMappingURL=index.js.map
